<template>
  <v-card-text class="py-0" v-if="tariff">
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
        <v-row>
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-img :src="tariff.pic" width="120" />
          </v-col>

          <v-col cols="12" sm="12" md="5" lg="5">
            <v-row>
              <v-col cols="12" sm="7" md="7" lg="7" class="body-2">
                <h1>{{tariff.name}}</h1>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5" md="5" lg="5" class="body-2">
                <h3>{{tariff.vehicleType}}</h3>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="3" lg="3" class="text-right">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="body-2">
                <v-btn @click="bookNow">{{$i18n.t('Book Now')}}</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="body-2">
                <v-btn @click="getQuote">{{$i18n.t('Get Quotation')}}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "TariffRow",
  props: {
    value: {
      default: null,
    },
    selected: {
      default: false,
    },
    refresh: {
      default: null,
    },
  },
})
export default class TariffRow extends Vue {
  tariff = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  bookNow() {
    this.$emit("bookNow", this.tariff);
  }

  getQuote() {
    this.$emit("getQuote", this.tariff);
  }

  async deleteTariff(tariff_id) {
    common.setLoading(true);
    try {
      await doGet("/api/rates/" + tariff_id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    if (this.value) {
      this.tariff = this.value;
      // this.tariff.limit_cg = this.limit;
      // this.tariff.limit_c = 2;

      // if (
      //   this.tariff.cityGroups != null &&
      //   this.tariff.cityGroups != undefined &&
      //   this.tariff.cityGroups.length > this.limit
      // ) {
      //   this.tariff.limit_cg = this.limit;
      // }
      // if (
      //   this.tariff.sourceCities != null &&
      //   this.tariff.sourceCities != undefined &&
      //   this.tariff.sourceCities.length > this.limit
      // ) {
      //   this.tariff.limit_c = 2;
      // }
    }
  }

  async changeStatus(tariff_id, status) {
    common.setLoading(true);
    try {
      await doGet("/api/rates/" + tariff_id + "/status/" + status);
      common.showMessage("Updated Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
      await this.refresh(1);
    }
    common.setLoading(false);
  }

  // async changeLimit(tariff, _limit, _for) {
  //   if (_for == "cities") {
  //     tariff.limit_c = _limit;
  //   } else if (_for == "cityGroups") {
  //     tariff.limit_cg = _limit;
  //   }
  // }

  @Watch("value")
  onValueChange(val) {
    this.tariff = val;
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.tariff.selected = val;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>
